module.exports = require("./mas");